import { render, staticRenderFns } from "./OrcamentoItemAlerta.vue?vue&type=template&id=7c4f9c71&scoped=true"
import script from "./OrcamentoItemAlerta.vue?vue&type=script&lang=js"
export * from "./OrcamentoItemAlerta.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItemAlerta.vue?vue&type=style&index=0&id=7c4f9c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4f9c71",
  null
  
)

export default component.exports